var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"w3-container w3-center footer"},[_vm._v("            \n    Built on the FIBI.Works platform. For details see "),_c('a',{attrs:{"target":"_blank","href":"https://fibi.works"}},[_vm._v("FIBI")]),_c('br'),_vm._v(" "),_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/termsconditions"}},[_vm._v("Terms")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4afced53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/FooterLayout.vue
// module id = 430
// module chunks = 1